import { makeStyles } from 'tss-react/mui';

export const useCopyEndpointModalStyles = makeStyles()(theme => ({
  endpointsDialog: {
    minWidth: 680,
    width: '100%',
    maxWidth: 850,

    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
    },
  },
  chainDescription: {
    marginBottom: theme.spacing(6),
    marginTop: theme.spacing(6),
  },
  chainSelectors: {
    marginBottom: theme.spacing(6),
  },
  copyEndpointButton: {
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  projectSelector: {
    maxWidth: '100%',
    marginBottom: theme.spacing(3),
    '&': {
      borderRadius: theme.shape.borderRadiusMd,
    },
    div: {
      boxShadow: 'none',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  projectTabContent: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    overflow: 'hidden',
    lineHeight: '22px',
  },
  enterpriseEndpoints: {
    marginBottom: theme.spacing(7.5),
  },
}));
